import type {
  IGenericFetchResult,
  INetworkResponse,
  IServiceQualificationLocationResponse,
  IServiceQualificationResponse,
  NBN_TECH_TYPE
} from '@belong/types';
import { addParamsToUrl, compile } from '@belong/url-utils';
import { FetchOptions, GenericAPI } from '../GenericAPI';
import { SERVICEABILITY_API_ENDPOINTS } from './types';

const PUBLIC_API_FETCH_OPTIONS: Pick<FetchOptions, 'includeCredentials' | 'includeIdToken'> = {
  includeCredentials: false,
  includeIdToken: false
};

export class ServiceQualificationAPI extends GenericAPI {
  async getServiceability(
    locationId: string,
    downstreamUpperRate?: number,
    currentTechType?: NBN_TECH_TYPE
  ): Promise<IGenericFetchResult<IServiceQualificationLocationResponse>> {
    const url = compile(SERVICEABILITY_API_ENDPOINTS.ADDRESS_ENTITY_LOCATION, { locationId });
    const queryParams = {
      ...(downstreamUpperRate && { downstreamUpperRate: downstreamUpperRate.toString() }),
      ...(currentTechType && { currentTechType })
    };

    // v2 endpoint: Location API returns a single object in `data`, not an array.
    return this.get(addParamsToUrl(url, queryParams), {}, PUBLIC_API_FETCH_OPTIONS);
  }

  getStrategicServiceability(addressJwt: string): INetworkResponse<IServiceQualificationResponse> {
    return this.post(SERVICEABILITY_API_ENDPOINTS.ADDRESS_ENTITY, { addressJwt }, PUBLIC_API_FETCH_OPTIONS);
  }
}

export default new ServiceQualificationAPI();
